module.exports = __webpack_public_path__ + "static/img/13020B_9_10_R_20221019_LC.6e75368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13020B_9_10_R_20221019_LC.png
// module id = iHYG
// module chunks = 0